import { appActionTypes } from 'src/@app/actionTypes';
import { IDateRange } from 'src/@app/props';

export const updateDateRangeAction = (dateRange: IDateRange) => ({
  type: appActionTypes.UPDATE_DATE_RANGE,
  dateRange,
});
